"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateSortPipe = void 0;
class DateSortPipe {
    transform(array, args) {
        if (typeof args[0] === 'undefined') {
            return array;
        }
        // eslint-disable-next-line prefer-const
        let direction = args[0][0];
        // eslint-disable-next-line prefer-const
        let column = args.replace('-', '');
        if (array !== undefined) {
            array.sort((a, b) => {
                // eslint-disable-next-line prefer-const
                let left = Number(new Date(a[column]));
                // eslint-disable-next-line prefer-const
                let right = Number(new Date(b[column]));
                return (direction === '-') ? right - left : left - right;
            });
        }
        return array;
    }
}
exports.DateSortPipe = DateSortPipe;
//# sourceMappingURL=dateSort.pipe.js.map